import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { branchShape, singleClickHoldsSettingsShape } from '@bibliocommons/bc-prop-types';
import * as AccountActions from '../actions/AccountActions';
import { sortedPickupBranchSelector } from '../selectors/LibrarySelector';
import { currentAccountSelector } from '../selectors/AuthSelector';
import SingleClickHoldsPanel from '../components/borrowing/sidebar/SingleClickHoldsPanel';

export class SingleClickHoldsPanelContainer extends BcReactComponent {
  render() {
    return (
      <SingleClickHoldsPanel {...this.props} />
    );
  }
}

SingleClickHoldsPanelContainer.propTypes = {
};

const mapStateToProps = (state) => {
  const branches = sortedPickupBranchSelector(state);
  const account = currentAccountSelector(state);
  const singleClickHoldsSettings = account && account.get('singleClickHoldsSettings', Immutable.Map());
  return {
    accountId: account.get('id'),
    branches,
    singleClickHoldsSettings
  };
};

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(AccountActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleClickHoldsPanelContainer);

SingleClickHoldsPanelContainer.propTypes = {
  accountId: PropTypes.number,
  singleClickHoldsEnabled: PropTypes.bool,
  branches: ImmutablePropTypes.listOf(branchShape),
  singleClickHoldsSettings: singleClickHoldsSettingsShape,
  accountActions: PropTypes.objectOf(PropTypes.func)
};



// WEBPACK FOOTER //
// ./app/containers/SingleClickHoldsPanelContainer.jsx